import { PAGE_TITLE_SUFFIX } from 'constants/meta';

// appends the page title suffix to the title param
const getPageTitle = (title = '') => `${title} ${PAGE_TITLE_SUFFIX}`;

export default getPageTitle;
